// extracted by mini-css-extract-plugin
export default {"containderAdjustmentRecords":"AdjustmentRecords_containderAdjustmentRecords__Gklyu","containderAdjustmentRecordsTable":"AdjustmentRecords_containderAdjustmentRecordsTable__2YY7Q"};